import { jsx as C } from "react/jsx-runtime";
function i(t) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "13",
      height: "18",
      viewBox: "0 0 13 18",
      fill: "rgb(var(--text-tertiary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ C("path", { d: "M10.5 14C11.6046 14 12.5 14.8954 12.5 16C12.5 17.1046 11.6046 18 10.5 18C9.3954 18 8.5 17.1046 8.5 16C8.5 14.8954 9.3954 14 10.5 14ZM2.5 14C3.60457 14 4.5 14.8954 4.5 16C4.5 17.1046 3.60457 18 2.5 18C1.39543 18 0.5 17.1046 0.5 16C0.5 14.8954 1.39543 14 2.5 14ZM10.5 7C11.6046 7 12.5 7.8954 12.5 9C12.5 10.1046 11.6046 11 10.5 11C9.3954 11 8.5 10.1046 8.5 9C8.5 7.8954 9.3954 7 10.5 7ZM2.5 7C3.60457 7 4.5 7.8954 4.5 9C4.5 10.1046 3.60457 11 2.5 11C1.39543 11 0.5 10.1046 0.5 9C0.5 7.8954 1.39543 7 2.5 7ZM10.5 0C11.6046 0 12.5 0.89543 12.5 2C12.5 3.10457 11.6046 4 10.5 4C9.3954 4 8.5 3.10457 8.5 2C8.5 0.89543 9.3954 0 10.5 0ZM2.5 0C3.60457 0 4.5 0.89543 4.5 2C4.5 3.10457 3.60457 4 2.5 4C1.39543 4 0.5 3.10457 0.5 2C0.5 0.89543 1.39543 0 2.5 0Z" })
    }
  );
}
export {
  i as SixDots
};
